import React from "react";

import Sejal from "../../Assets/Images/sejal.png";
import Harshal from "../../Assets/Images/harshal.jpg";
import ratna from "../../Assets/Images/ratna.jpg";
import harish from "../../Assets/Images/HMP.jpg";
import swati from "../../Assets/Images/swati.jpeg";

const teamMembers = [
  {
    name: "Harish Patil",
    role: "Functional Consultant ",
    description:
      "Responsible for mapping real business workflows into functional ERP modules, ensuring system designs match operational needs across finance, HR, production, and payroll.",
    image: harish,
  },
  {
    name: "Harshal Mahajan",
    role: "Full Stack Developer",
    description:
      "Responsible for building responsive and user-friendly website interfaces using modern frontend technologies.",
    image: Harshal,
  },
  {
    name: "Sejal Nehete",
    role: "Full Stack Developer",
    description:
      "Handles both frontend and backend development, API integration, and database design to build complete and efficient web applications.",
    image: Sejal,
  },

  {
    name: "Ratna Kasar",
    role: "React and .Net Developer",
    description:
      "Supports website structure, content alignment, and ensures consistency in design and presentation.",
    image: ratna,
  },
  {
    name: "Swati Sonawane",
    role: "Jr Full stack developer",
    description:
      "Works backend development, API integration, database design, and overall application functionality.",
    image: swati,
  },


];


const Teams = () => {
  return (
    <section className="bg-black py-20 px-6">
      <div className="text-center mb-14">
        <h2 className="text-4xl font-bold text-white">
          Our Website Development Team
        </h2>
        <p className="mt-3 text-gray-400">
          The technical experts behind our website development
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className="bg-gray-900 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 text-center hover:-translate-y-1"
          >
            <img
              src={member.image}
              alt={member.name}
              className="w-32 h-32 mx-auto rounded-full object-cover mb-4 border-4 border-gray-700"
            />

            <h3 className="text-xl font-semibold text-white">
              {member.name}
            </h3>

            <p className="text-sm text-indigo-400 font-medium mt-1">
              {member.role}
            </p>

            <p className="mt-3 text-gray-400 text-sm leading-relaxed">
              {member.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Teams;
